import { Button, Flex } from "antd";

interface TablePopoverFooterButtonsProps {
    readonly resetFilters: () => void;
    readonly onClose: () => void;
}

export const TablePopoverFooterButtons = ({ resetFilters, onClose }: TablePopoverFooterButtonsProps) => (
    <Flex justify="flex-end">
        <Button type="link" onClick={resetFilters}>
            Reset
        </Button>
        <Button type="link" onClick={onClose}>
            Close
        </Button>
    </Flex>
);
